import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { animate, style, transition, trigger } from '@angular/animations';
import { Badge, Hostel } from '@app/services/api/api.service';

@Component({
  selector: 'app-hostel-badges',
  templateUrl: './badges.component.html',
  styleUrls: ['./badges.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(-8px)', opacity: 0.4 }),
        animate(
          '0.15s ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class BadgesComponent {
  @Input()
  public hostel?: Hostel;

  @Output()
  public anchorClicked = new EventEmitter<string>();
  @Output()
  public showDialog = new EventEmitter<string>();

  public badges: Badge[] = [];
  public badgeGroups: Array<{ count: number; badge: Badge }>;

  private destroyed = new Subject<void>();

  ngOnChanges() {
    if (this.hostel?.reviews) {
      this.badges = this.hostel.reviews.reduce((acc, cv) => {
        acc.push(...cv.badges);
        return acc;
      }, [] as Array<Badge>);
      this.badgeGroups = (this.badges ?? [])
        .reduce((acc, cv) => {
          const match = acc.find((group) => group.badge?.name === cv.name);
          if (match) {
            match.count++;
          } else {
            acc.push({ count: 1, badge: cv });
          }
          return acc;
        }, [] as Array<{ count: number; badge: Badge }>)
        .sort((a, b) => {
          return b.count - a.count;
        });
    }
  }

  ngOnInit() {
    // todo only show these when fully hydrated
    // if (this.hostel) {
    //   this.badges = this.hostel?.reviews.reduce((acc, cv) => {
    //     acc.push(...cv.badges);
    //     return acc;
    //   }, ([] as Array<Badge>));
    //   this.badgeGroups = this.badges?.reduce((acc, cv) => {
    //     const match = acc.find(group => group.badge?.name === cv.name);
    //     if (match) {
    //       match.count++;
    //     } else {
    //       acc.push({count: 1, badge: cv});
    //     }
    //     return acc;
    //   }, ([] as Array<{count: number, badge: Badge}>)).sort((a, b) => {
    //     return b.count - a.count;
    //   });
    // }
  }

  public addToMap() {
    this.showDialog.emit();
  }

  public recommend() {
    this.showDialog.emit();
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
